import { CartService, CartServiceModule } from '@b2b/common/services';
import angular from 'angular';
import { clamp } from 'lodash';
import moment from 'moment-timezone';

OrderCouponsDirective.$inject = ['$timeout', '$filter', 'ApiService', 'CartService'];
function OrderCouponsDirective($timeout, $filter, ApiService, CartService: CartService) {
  OrderCouponsController.$inject = ['$scope'];
  function OrderCouponsController($scope) {
    const ctrl = {
      model: [] as { code: string; valid?: number }[],

      list: [],

      amount: 0,
      codes: CartService.coupons.codes,
      focusIndex: 0,

      text: {
        coupons: {
          heading: 'Coupons',
          message: 'Have a coupon code?',
          placeholder: 'Enter code',
          applied: 'Coupon or promo code applied',
        },
      },
      errors: false as Record<string, unknown> | false,

      init: function () {
        this.model = this.getModel();

        this.prune();
        this.applyCoupons();

        $scope.$on('Cart::CouponRefresh', angular.bind(this, this.applyCoupons));
      },

      searchCoupons: function (search, index) {
        const startDate = moment().startOf('day').format();

        ApiService.coupons
          .list({
            pageSize: 10,
            sortField: 'name',
            sortDirection: 'asc',
            startDate: startDate,
            search: search,
          })
          .then(
            function searchCouponsSuccess(response) {
              $timeout(function () {
                ctrl.list = ctrl.processCoupons(response.data.payload.list);

                $scope.$broadcast('CustomTypeahead::FilterResults', {
                  field: 'combobox-input-' + 'form-coupon-' + index,
                });
              });
            },
            function searchCouponsFailed(response) {
              console.error(response);
            },
          );
      },

      addCoupon: function addCoupon(code) {
        const emptyCodes = this.model.filter(function (coupon) {
          return coupon.code === '';
        });

        if (!emptyCodes.length) {
          this.model.push({ code: code || '' });

          this.focusLastCouponInput();
        }
      },

      removeCoupon: function removeCoupon(index) {
        this.model.splice(index, 1);
        this.applyCoupons();
      },

      focusLastCouponInput: function focusLastCouponInput() {
        const lastIndex = clamp(this.model.length - 1, 0, this.model.length);
        $timeout(function () {
          $('#combobox-input-form-coupon-' + lastIndex).trigger('focus');
        }, 0);
      },

      update: function () {
        $scope.$emit('OrderCoupons::Updating');
        this.prune();
        this.setModel(this.model);
        CartService.coupons.validate().then(this.success.update, this.error.update);
      },

      prune: function () {
        if (this.model.length === 0) {
          // Add an empty input field automatically
          this.model.push({ code: '' });
        }
      },

      validTest: function validTest(index) {
        return !(this.errors && !!this.errors['form-coupon-' + index]);
      },

      getErrorMessage: function getErrorMessage(index) {
        const error = this.errors ? this.errors['form-coupon-' + index] : null;

        return error ? error.message : undefined;
      },

      isAriaInvalidCoupon: function isAriaInvalidCoupon(index) {
        return this.validTest(index) ? true : undefined;
      },

      isAriaDescribedbyCoupon: function isAriaDescribedbyCoupon(index) {
        return this.validTest(index) ? 'form-coupon-' + index + '-error-message' : undefined;
      },

      isCodeValid: function (code) {
        const intCode = parseInt(code, 10);

        return intCode === this.codes.VALID_COUPON_CODE;
      },

      isCodeInvalid: function (code) {
        const intCode = parseInt(code, 10);

        return intCode === this.codes.INVALID_COUPON_CODE || intCode === this.codes.CONFLICTING_COUPON_CODE;
      },

      validateCode: function (code) {
        let result = true;

        if (!angular.isUndefined(code)) {
          result = this.isCodeValid(code);
        }

        return result;
      },

      validate: function () {
        CartService.coupons.validate().then(this.success.validate, this.error.validate);
      },

      hasItems: function () {
        return CartService.itemCount;
      },

      process: function (codes) {
        let result = [];

        angular.forEach(codes, function (v1) {
          result = result.concat(
            $filter('filter')(ctrl.list, function (v2) {
              const code = typeof v1 === 'string' ? v1 : v1.code;

              if (v2.code === code) {
                return v2;
              }
            }),
          );
        });

        return result;
      },

      processCoupons: function (coupons) {
        angular.forEach(coupons, function (coupon) {
          coupon.name = coupon.code;
        });
        return coupons;
      },

      getCouponCodes: function () {
        return this.model
          .map(function (item) {
            return typeof item.code === 'string' ? item.code : item.code.code;
          })
          .filter(function (code) {
            return (code || '').trim().length > 0;
          });
      },

      /**
       * Validates coupons and updates cart when needed
       */
      applyCoupons: function () {
        const codes = this.getCouponCodes();
        const valid = CartService.coupons.validateCoupons(codes);
        this.errors = CartService.coupons.errors;

        if (valid) {
          this.update();
        }
      },

      getModel: function getModel() {
        const model = CartService.coupons.getModel();

        return model.map(function (item) {
          return typeof item === 'string' ? { code: item } : item;
        });
      },

      setModel: function setModel(coupons) {
        this.model = coupons;

        const model = this.model.map(function (item) {
          return typeof item.code === 'string' ? item : item.code;
        });

        CartService.coupons.setModel(model);
      },

      success: {
        /**
         * Service contains updated model with validation
         * See CartService.coupons.validate method
         *
         * @param response
         */
        validate: function (response) {
          ctrl.model = ctrl.getModel();
          ctrl.errors = CartService.coupons.errors;
          ctrl.prune();
        },

        update: function (response) {
          ctrl.success.validate(response);

          CartService.coupons.update().then(function () {
            $scope.$emit('OrderCoupons::Updated');
          });
        },
      },

      error: {
        validate: function (response) {},
        update: function (response) {
          $scope.$emit('OrderCoupons::Updated');
        },
      },

      onSelect: function (index) {
        // next tick
        $timeout(function () {
          $scope.orderCoupons.update();
        }, 10);
      },

      onBlur: function () {
        $scope.orderCoupons.applyCoupons();
      },
    };

    $scope.orderCoupons = ctrl;
    $scope.orderCoupons.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/coupons/coupons.tpl.html',
    scope: {},

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderCouponsController,
  };
}

export const OrderCouponsDirectiveModule = angular
  .module('acme.common.directive.order.coupons', ['acme.common.service.api', CartServiceModule])
  .directive('orderCoupons', OrderCouponsDirective).name;
